import React, { useContext, useEffect } from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';

import { Table } from 'components/table/table';
import {
  BreadcrumbsCtx,
  initialBreadcrumbs,
} from 'components/portfolio/breadcrumbs-ctx';
import { PageKey, SortOrder } from 'enums';
import { FavouriteArchivalEntity } from 'types';
import { TableColumn } from 'components/table/table-types';
import { useTableHook } from 'components/table/table-hook';
import { TableCellDate } from 'components/table-cell/date';
import { tableCellEnumFactory } from 'components/table-cell/enum-cell';

import { fetchMyFavourites, useArchivalEntityTypes } from './favourite-api';
import { FavouriteDetailCell } from './favourite-detail-cell';
import { RemoveFavouriteDetailCell } from './favourite-remove-favourite-cell';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    table: {
      margin: theme.spacing(2),
    },
    wrapper: {
      backgroundColor: '#FAFAFA',
      minHeight: 100,
      padding: '0px 20px',
    },
  })
);

const headCells: TableColumn[] = [
  {
    id: 'label',
    label: 'Název',
    CellComponent: FavouriteDetailCell,
  },
  {
    id: 'added',
    label: 'Přidáno',
    CellComponent: TableCellDate,
  },
  {
    id: 'archivalEntityType',
    label: 'Typ',
    CellComponent: tableCellEnumFactory(useArchivalEntityTypes, false),
  },
  {
    id: 'id',
    label: '',
    CellComponent: RemoveFavouriteDetailCell,
    width: 120,
  },
];

export function Favourite() {
  const classes = useStyles();

  const { setBreadcrumbs } = useContext(BreadcrumbsCtx);
  const tableProps = useTableHook<FavouriteArchivalEntity>({
    fetchFunction: fetchMyFavourites,
    params: { sort: [{ field: 'added', order: SortOrder.ASC }] },
  });

  useEffect(() => {
    setBreadcrumbs([
      ...initialBreadcrumbs.breadcrumbs,
      {
        title: 'Oblíbené',
        key: PageKey.PORTFOLIO_FAVOURITE,
      },
    ]);
  }, [setBreadcrumbs]);

  return (
    <Grid container>
      <Grid item xs={12} className={classes.table}>
        <Table<FavouriteArchivalEntity>
          {...tableProps}
          columns={headCells}
          expandableRows={false}
        />
      </Grid>
    </Grid>
  );
}
